// extracted by mini-css-extract-plugin
export var downArrow = "_9d-0";
export var infoTooltipIcon = "_9d-3";
export var label = "_9d-1";
export var optionCard = "_9d-4";
export var upArrow = "_9d-2";